import { BlockScrollStrategy, Overlay } from "@angular/cdk/overlay";
import { Component, Injector, NgZone, OnDestroy, OnInit } from "@angular/core";
import { MAT_SELECT_SCROLL_STRATEGY as MAT_SELECT_SCROLL_STRATEGY } from "@angular/material/select";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import {
  ANALYTICS,
  COMMON_CONSTANTS,
  ENTITLEMENT_ACTIVITYNAMES,
  MANAGE_LINE_CONST,
} from "./common/core/common.constants";
import { HttpCacheService } from "./services/http-cache.service";
import { UtilsService } from "./services/utils.service";
import { Location } from "@angular/common";
import { isNullOrUndefined } from 'src/app/services/utils';
import { OktaAuthorizationService } from "./services/okta-auth-service";
import { PnpClientService } from "src/pnpframework/public-api";
import { Subscription } from "rxjs";
import { singleSpaPropsSubject } from "src/single-spa/single-spa-props";
import { HelperUtilityService } from "./services/helper-utility.service";
export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  host: { class: 'acctmgmt' },
  providers: [
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  title = COMMON_CONSTANTS.APP_TITLE;
  // Feature flag for AHUB
  enableAhubFlow: boolean = false;
  isRunningInGlobalNav: boolean = false;
  path = "";
  _reloadSubscription: Subscription;
  private _singleSpaSubscription: Subscription;
  private _contextSubscription: Subscription;
  private storedCookie: string;
  private cookieInterval:any;

  private router: Router;
  private ngZone: NgZone;
  private storage: HttpCacheService;
  private utlSrv: UtilsService;
  private _helperUtilSvc: HelperUtilityService;
  private location: Location;
  public oktaAuth: OktaAuthorizationService;
  private _pnpClientService: PnpClientService;
  private activitySubs: Subscription;
  isBannerVisible: boolean = false;
  isMultiBannerVisible: boolean = false;
  isRestrictionBannerVisible: boolean = false;
  isFailureBannerVisible: boolean = false;


  constructor(private injector: Injector) {
    this.router = this.injector.get<Router>(Router);
    this.ngZone = this.injector.get<NgZone>(NgZone);
    this.storage = this.injector.get<HttpCacheService>(HttpCacheService);
    this.utlSrv = this.injector.get<UtilsService>(UtilsService);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.location = this.injector.get<Location>(Location);
    this.oktaAuth = this.injector.get<OktaAuthorizationService>(OktaAuthorizationService);
    this._pnpClientService = this.injector.get<PnpClientService>(PnpClientService);

    this.isRunningInGlobalNav = this._pnpClientService.isRunningInGlobalNav();
    this._reloadSubscription = this._pnpClientService.reload$.subscribe((url: string) => {
      const formattedUrl = new URL(url || "", window.location.origin);
      if (url && url.startsWith(environment.baseHref)) {
        this.router.navigateByUrl(formattedUrl.pathname + formattedUrl.search, { skipLocationChange: true });
      }
    });
    this.initApp();
  }

  loadScriptMethod(scriptSrc) {
    let node = document.createElement("script"); // creates the script tag
    var inlineScript = document.createTextNode(scriptSrc);
    node.appendChild(inlineScript);
    document.getElementsByTagName("head")[0].appendChild(node);
  }

  checkForCookieManipulation() {
    this.ngZone.runOutsideAngular(() => {
      this.cookieInterval = setInterval(() => {
        const currentCookie = this.utlSrv.getCookie(
          COMMON_CONSTANTS.ORG_USER_TYPE
        );
        if (this.storedCookie !== currentCookie) {
          clearInterval(this.cookieInterval);
          this.logout();
        }
      }, COMMON_CONSTANTS.DIGITS.TWO_HUNDRED_FIFTY);
    });
  }
  private logout() {
    if (
      !isNullOrUndefined(
        this.storage.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE)
      ) &&
      this.storage.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) ===
        COMMON_CONSTANTS.OKTA_KEY
    ) {
      this.oktaAuth.logOutFromOkta();
    } else {
      this.oktaAuth.logOutFromIAM();
    }
  }
  updateEntitlementLH() {
    if (environment.ENABLE_LIGHTHOUSE_IN_AHUB && this._helperUtilSvc.isLhUser()) {
      for (let item in ENTITLEMENT_ACTIVITYNAMES) {
        // Note: item contains keys of ENTITLEMENT_ACTIVITYNAMES not the value
        if(item !== "CHANGE_RATE_PLAN" && item !== "CHANGE_SERVICE_SINGLE" && item !== "LINE_OF_SERVICE" &&
          item !== ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_BULK && item !== ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_SINGLE &&
          item !== "MANAGE_LINES"){
          const suffix = ENTITLEMENT_ACTIVITYNAMES[item]?.slice(-COMMON_CONSTANTS.DIGITS.THREE);
          ENTITLEMENT_ACTIVITYNAMES[item] = suffix !== COMMON_CONSTANTS.LH_SUFFIX ? ENTITLEMENT_ACTIVITYNAMES[item] + COMMON_CONSTANTS.LH_SUFFIX : ENTITLEMENT_ACTIVITYNAMES[item];
        }
      }
    }
  }

  initDigitalDataWhenReady() {
    window.addEventListener('digitalDataReady', function (){
      window.digitalData = window.digitalData || {};
      window.digitalData.page = window.digitalData.page || {};
      window.digitalData.page.category = window.digitalData.page.category || {};
      window.digitalData.page.pageInfo = window.digitalData.page.pageInfo || {};
      window.digitalData.events = window.digitalData.events || [];
      window.digitalData.user = window.digitalData.user || {};
      window.digitalData.customer = window.digitalData.customer || {};
      window.digitalData.customer.company = window.digitalData.customer.company || {};

      if (sessionStorage.getItem(COMMON_CONSTANTS.AUTH_TYPE) !== COMMON_CONSTANTS.IAM_KEY) {
        window.digitalData.page.pageInfo.site = ANALYTICS.SITE_CARE;
      } else {
        window.digitalData.page.pageInfo.site = ANALYTICS.SITE_AHUB;
      }
    }, false);
  }

  initApp(): void {
    if (!this._pnpClientService.isRunningInGlobalNav()) {
      return;
    }
    this.updateEntitlementLH();
    this._singleSpaSubscription = singleSpaPropsSubject.subscribe(
      ({ messageBus }) => {
        this._pnpClientService.connect(messageBus);
        this._pnpClientService.setTitle("AM App");
        this._pnpClientService.setNavList(environment.PNP_CONFIG.microAppId, [
          {
            id: "account-management/home",
            label: "Manage Lines",
            activities: [`BAN.${ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES}`],
          },
          {
            id: "account-management/transaction-history",
            label: "Transactions",
            activities: [
              `BAN.${ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY}`,
            ],
          },
          {
            id: "account-management/approval-dashboard",
            label: "Approval Dashboard",
            activities: [`USER.${ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD}`],
          },
        ]);
      }
    );

    this._contextSubscription = this._pnpClientService.context$.subscribe(
      (pnpContext) => {
        this.storage.putInSessionStoarage(
          COMMON_CONSTANTS.AUTH_TYPE,
          pnpContext[COMMON_CONSTANTS.AUTH_TYPE] || "iam"
        );

        this.storage.putInSessionStoarage(
          COMMON_CONSTANTS.ORG_ID_KEY,
          pnpContext[COMMON_CONSTANTS.ORG_ID_KEY] ||
            pnpContext["orgId"] ||
            this.storage.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY) ||
            ""
        );

        this.storage.putInSessionStoarage(
          COMMON_CONSTANTS.USER_ID,
          pnpContext[COMMON_CONSTANTS.USER_ID] ||
            this.storage.getFromSessionStorage(COMMON_CONSTANTS.USER_ID) ||
            ""
        );
      }
    );
    this.initDigitalDataWhenReady();
  }

  ngOnInit(): void {
    this.enableAhubFlow = environment.ENABLE_AHUB_FLOW;
    this.storage.putInSessionStoarage(COMMON_CONSTANTS.ROUTES_TXT, "{}");
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    const urls: any = {};
    const url = [
      COMMON_CONSTANTS.HOME_URL,
      MANAGE_LINE_CONST.REDIRECT_TO_MANAGE_LINES,
    ];

    this.activitySubs = this.utlSrv.changeActivityForLH_User$.subscribe((data) => {
        if (data) {
          this.updateEntitlementLH();
        }
      })


    this.storedCookie = this.utlSrv.getCookie(COMMON_CONSTANTS.ORG_USER_TYPE);
    if (environment.ENABLE_WALKMEIN) {
     this.checkingWalkMeInEnv();
    }
    if (environment.ENABLE_CW_NON_IOT) {
      this.checkForCookieManipulation();
    }

    if (environment.ENABLE_TAGGING) {
      if (environment.production) {
        (function (a, b, c, d) {
          a = "https://tags.tiqcdn.com/utag/tmobile/nextgen/prod/utag.js";
          b = document;
          c = "script";
          d = b.createElement(c);
          d.src = a;
          d.type = "text/java" + c;
          d.async = true;
          a = b.getElementsByTagName(c)[0];
          a.parentNode.insertBefore(d, a);
        })();
      } else {
        (function (a, b, c, d) {
          a = "https://tags.tiqcdn.com/utag/tmobile/nextgen/qa/utag.js";
          b = document;
          c = "script";
          d = b.createElement(c);
          d.src = a;
          d.type = "text/java" + c;
          d.async = true;
          a = b.getElementsByTagName(c)[0];
          a.parentNode.insertBefore(d, a);
        })();
      }
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        urls.prevUrl = this.router.url;
      }
      if (event instanceof NavigationEnd) {
        urls.currentUrl = this.router.url;
      }
      if (
        url.indexOf(urls.prevUrl) === -1 ||
        url.indexOf(urls.currentUrl) === -1
      ) {
        this.utlSrv.homeSearchText = "";
      }
      this.storage.putInSessionStoarage(
        COMMON_CONSTANTS.ROUTES_TXT,
        JSON.stringify(urls)
      );
    });

    this.router.events.subscribe((val) => {
      this.path = this.location.path();
    });
    this.utlSrv.banner2FA.subscribe(res => {
      this.isBannerVisible = res;
    });
    this.utlSrv.multiBanner.subscribe(res => {
      this.isMultiBannerVisible = res;
    });
    this.utlSrv.restrictionBanner.subscribe(res => {
      this.isRestrictionBannerVisible = res;
    });
    this.utlSrv.banner2FAFailure.subscribe(res => {
      this.isFailureBannerVisible = res;
    });
  }

  checkingWalkMeInEnv() {
    if (environment.production) {
      this.loadScriptMethod(
        '(function() {var walkme = document.createElement("script"); walkme.type = "text/javascript"; walkme.async = true; walkme.src = "https://cdn.walkme.com/users/626f6ee16cfe420f8e87a0858d5f7107/walkme_626f6ee16cfe420f8e87a0858d5f7107_https.js"; var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(walkme, s); window._walkmeConfig ={smartLoad:true}; })();'
      );
    } else {
      this.loadScriptMethod(
        '(function() {var walkme = document.createElement("script"); walkme.type = "text/javascript"; walkme.async = true; walkme.src = "https://cdn.walkme.com/users/626f6ee16cfe420f8e87a0858d5f7107/test/walkme_626f6ee16cfe420f8e87a0858d5f7107_https.js"; var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(walkme, s); window._walkmeConfig ={smartLoad:true}; })();'
      );
    }
  }

  ngOnDestroy(): void {
    if (!this._pnpClientService.isRunningInGlobalNav()) {
      return;
    }
    if(this.activitySubs){
      this.activitySubs.unsubscribe();
    }
    if(this.cookieInterval){
    clearInterval(this.cookieInterval);
    }
    this._reloadSubscription.unsubscribe();
    this._singleSpaSubscription.unsubscribe();
    this._contextSubscription.unsubscribe();
  }

  close() {
    this.isMultiBannerVisible = false;
    this.isRestrictionBannerVisible = false;
  }
}
